import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isPublicPath } from "@/lib/publicRoutes";
import { useInstrumentSans } from "@/components/home/HomeApple";
import "@/styles/public.css";

/** Zet de class `pub` op <body> voor publieke pagina's; puur visueel, dashboards blijven ongemoeid. */
export default function PublicStyleSync() {
  const { pathname } = useLocation();
  useInstrumentSans();
  useEffect(() => {
    const isCaregiverDash = pathname.startsWith("/mijn-praktijk");
    const on = (isPublicPath(pathname) && pathname !== "/") || isCaregiverDash;
    document.body.classList.toggle("pub", on);
    document.body.classList.toggle("pub-dash", isCaregiverDash);
  }, [pathname]);
  return null;
}
